import { Reducer, Action } from 'redux'
import { ITruck } from 'apps/fleet-planner/types'
import { ICreateTruckState } from 'apps/fleet-planner/types/truck'
import { CREATE_TRUCK_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/truck'

const {
  CREATE_TRUCK_FAILURE,
  CREATE_TRUCK_REQUEST,
  CREATE_TRUCK_SUCCESS,
} = CREATE_TRUCK_ACTION_TYPES

interface ICreateTruckRequestAction extends Action<string> {}

interface ICreateTruckFailureAction extends Action<string> {
  error: string
}

export interface ICreateTruckSuccessAction extends Action<string> {
  payload: {
    truck: ITruck
  }
}

type CreateTruckActions =
  | ICreateTruckRequestAction
  | ICreateTruckFailureAction
  | ICreateTruckSuccessAction

const defaultState: ICreateTruckState = {
  fetching: false,
  error: undefined,
  truck: undefined,
}

export const createTruckReducer: Reducer<ICreateTruckState, CreateTruckActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case CREATE_TRUCK_REQUEST: {
      return {
        ...state,
        error: undefined,
        fetching: true,
      }
    }
    case CREATE_TRUCK_FAILURE: {
      const { error } = action as ICreateTruckFailureAction
      return {
        ...state,
        fetching: false,
        error,
      }
    }
    case CREATE_TRUCK_SUCCESS: {
      const {
        payload: { truck },
      } = action as ICreateTruckSuccessAction
      return {
        ...state,
        error: undefined,
        fetching: false,
        truck,
      }
    }
    default:
      return state
  }
}
